import { getBonusPoints, getMe, getOrders, getTransactions, orderBonus, patchMe, setPassword, getUserDetailsById, getAdminUser } from '@/api/user';

const user = {
  namespaced: true,
  state: () => ({
    status: {
      profile: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      orders: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      transactions: {
        initialized: false,
        refreshing: false,
        error: false,
      },
      bonusPoints: {
        initialized: false,
        refreshing: false,
        error: false,
      },
    },
    profile: {
      id: 0,
      username: '',
      firstName: '',
      lastName: '',
      email: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zip: '',
      dayPhone: '',
      eveningPhone: '',
      residenceCountry: '',
      pointsAvailable: 0,
      clientId: 0,
      isAdmin: false,
    },
    bonusPointsAvailable: 0,
    orders: [],
    transactions: [],
    userClients: {},
    isUserDivyAdmin: localStorage.getItem('isDivvyAdmin'),
  }),
  getters: {
    getUserProfile(state) {
      return state.profile ? state.profile : {};
    },
    getUserClients(state) {
      return state.userClients ? state.userClients : {};
    },
    getIsUserDivyAdmin(state) {
      return state.isUserDivyAdmin;
    },
    canShowTravelSunsetBanner(state) {
      const allowedClientIds = [500292, 500085, 500087, 500247, 252, 500287];
      return allowedClientIds.includes(state.profile.clientId);
    },
  },
  actions: {
    fetchProfile({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'profile');
        commit('SET_ERROR_FALSE', 'profile');
        getMe()
          .then((user) => {
            commit('SET_INITIALIZED_TRUE', 'profile');
            commit('SET_REFRESHING_FALSE', 'profile');
            commit('SET_PROFILE', user);
            commit('SET_USER_CLIENTS', user ? user : {});
            // getUserDetailsById({ userId: user.id })
            //   .then((user) => {
            //     commit('SET_USER_CLIENTS', user ? user : {});
            //   })
            //   .catch(() => {
            //     console.log('error while get clients fetch store');
            //   });
            resolve();
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'profile');
            commit('SET_ERROR_TRUE', 'profile');
            reject(err);
            dispatch('auth/logOut', null, { root: true });
          });
      });
    },
    fetchAdminProfile({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'profile');
        commit('SET_ERROR_FALSE', 'profile');
        getAdminUser()
          .then((user) => {
            commit('SET_INITIALIZED_TRUE', 'profile');
            commit('SET_REFRESHING_FALSE', 'profile');
            commit('SET_PROFILE', user);

            resolve();
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'profile');
            commit('SET_ERROR_TRUE', 'profile');
            reject(err);
            dispatch('auth/logOut', null, { root: true });
          });
      });
    },
    setProfile({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        patchMe(
          data.id,
          data.firstName,
          data.lastName,
          data.email,
          data.address1,
          data.address2,
          data.city,
          data.zip,
          data.state,
          data.dayPhone,
          data.eveningPhone
        )
          .then(() => {
            resolve();
            dispatch('fetchProfile');
          })
          .catch((err) => {
            reject(err);
            dispatch('fetchProfile');
          });
      });
    },
    setPassword({ commit, dispatch }, data) {
      return new Promise((resolve, reject) => {
        setPassword(data.currentPassword, data.newPassword)
          .then(() => {
            resolve();
            dispatch('fetchProfile');
          })
          .catch((err) => {
            reject(err);
            dispatch('fetchProfile');
          });
      });
    },
    fetchOrders({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'orders');
        commit('SET_ERROR_FALSE', 'orders');
        getOrders(0, 20)
          .then((items) => {
            commit('SET_INITIALIZED_TRUE', 'orders');
            commit('SET_REFRESHING_FALSE', 'orders');
            commit('SET_ORDERS', items);
            resolve();
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'orders');
            commit('SET_ERROR_TRUE', 'orders');
            reject(err);
            dispatch('auth/logOut', null, { root: true });
          });
      });
    },
    fetchTransactions({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'transactions');
        commit('SET_ERROR_FALSE', 'transactions');
        getTransactions(0, 50)
          .then((items) => {
            commit('SET_INITIALIZED_TRUE', 'transactions');
            commit('SET_REFRESHING_FALSE', 'transactions');
            commit('SET_TRANSACTIONS', items);
            resolve();
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'transactions');
            commit('SET_ERROR_TRUE', 'transactions');
            reject(err);
            dispatch('auth/logOut', null, { root: true });
          });
      });
    },
    fetchBonusPoints({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        commit('SET_REFRESHING_TRUE', 'bonusPoints');
        commit('SET_ERROR_FALSE', 'bonusPoints');
        getBonusPoints()
          .then((points) => {
            commit('SET_INITIALIZED_TRUE', 'bonusPoints');
            commit('SET_REFRESHING_FALSE', 'bonusPoints');
            commit('SET_BONUS_POINTS_AVAILABLE', points);
            resolve();
          })
          .catch((err) => {
            commit('SET_REFRESHING_FALSE', 'bonusPoints');
            commit('SET_ERROR_TRUE', 'bonusPoints');
            reject(err);
            dispatch('auth/logOut', null, { root: true });
          });
      });
    },
    orderBonus({ commit, dispatch }, item) {
      return new Promise((resolve, reject) => {
        orderBonus(item)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getClient({ commit }, params) {
      return new Promise((resolve, reject) => {
        console.log(params, 'get clients');
        getUserDetailsById(params)
          .then((user) => {
            commit('SET_USER_CLIENTS', user ? user : {});
          })
          .catch(() => {
            console.log('error while get clients fetch store');
          });
      });
    },
    setIsDivvyAdmin({ commit }, isDivvyAdmin) {
      commit('SET_IS_DIVVY_ADMIN', isDivvyAdmin);
    },
  },
  mutations: {
    SET_INITIALIZED_TRUE: (state, dataName) => {
      state.status[dataName].initialized = true;
    },
    SET_REFRESHING_TRUE: (state, dataName) => {
      state.status[dataName].refreshing = true;
    },
    SET_REFRESHING_FALSE: (state, dataName) => {
      state.status[dataName].refreshing = false;
    },
    SET_ERROR_TRUE: (state, dataName) => {
      state.status[dataName].error = true;
    },
    SET_ERROR_FALSE: (state, dataName) => {
      state.status[dataName].error = false;
    },
    SET_PROFILE: (state, payload) => {
      state.profile.id = payload.id;
      state.profile.username = payload.username;
      state.profile.firstName = payload.firstName;
      state.profile.lastName = payload.lastName;
      state.profile.email = payload.email;
      state.profile.address1 = payload.address1;
      state.profile.address2 = payload.address2;
      state.profile.city = payload.city;
      state.profile.state = payload.state;
      state.profile.zip = payload.zip;
      state.profile.dayPhone = payload.dayPhone;
      state.profile.eveningPhone = payload.eveningPhone;
      state.profile.residenceCountry = payload.residenceCountry;
      state.profile.pointsAvailable = payload.pointsAvailable;
      state.profile.clientId = parseInt(payload.client);
      state.profile.isAdmin = payload.isAdmin;
    },
    SET_ORDERS: (state, payload) => {
      state.orders = payload;
    },
    SET_TRANSACTIONS: (state, payload) => {
      state.transactions = payload;
    },
    SET_BONUS_POINTS_AVAILABLE: (state, payload) => {
      state.bonusPointsAvailable = payload;
    },
    SET_USER_CLIENTS: (state, payload) => {
      state.userClients = {
        id: payload.id,
        userType: payload.admin,
        client: payload.client,
        clients: payload.clients,
        hasAccessToNewApp: payload.hasAccessToNewApp,
      };
    },
    SET_IS_DIVVY_ADMIN: (state, payload) => {
      state.isUserDivyAdmin = payload;
    },
  },
};

export default user;
